// reviewList.js

import { baseURL } from 'utils/api'
import Dictionary from '../dictionary'
import axios from 'axios'

const { reviewList } = Dictionary

const reviewListServies = {
  view: async (paramsObj) => {
    return axios.get(baseURL + reviewList.create(),{params: paramsObj})
  },
   listDetail: async (id,paramsObj) => {
    return axios.get(baseURL + reviewList.listDetail(id),{params: paramsObj})
  },
  add: async (data) => {
    return axios.post(baseURL + reviewList.create(), data)
  },
  delete: async (id) => {
    return axios.delete(baseURL + reviewList.delete(id))
  },
  edit: async (id, data) => {
    return axios.put(baseURL + reviewList.update(id), data)
  },
  getDetailById: async (id,paramsObj) => {
    return axios.get(baseURL + reviewList.getById(id),{params: paramsObj})
  },
}
export default reviewListServies